import styled from 'styled-components';

export const Logo = styled.img`
  margin-left: 65px;
  margin-top: 10px;
  margin-bottom: 5px;
`;
